import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { notification } from 'antd';
import { isEmpty } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';

import Header from '../../header/header';

import { AuthWrapper } from '../style';

import { TokenVerification, SendVerificationEmail } from '../../../slices/auth';
import { toast } from '../../../hooks/use-toast';

import { STORAGE_IMAGE_URL } from '../../../constants/storage';
const EmailVerifactionImage = `${STORAGE_IMAGE_URL}/newImages/emailVerifaction.png`;

const PasswordEmailVerifaction = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const emailParam = queryParams.get('email');
  const { user, sendVerificationEmailLoading } = useSelector(state => state?.auth || {});
  const { email } = user || {};

  const emailReset = emailParam || email;

  const handleResendEmail = async () => {
    if (isEmpty(emailReset)) {
      notification.error({
        message: 'Verification Email',
        description: 'Email not found',
        top: 65
      });
      return;
    }
    const user = { email: emailReset };
    await dispatch(SendVerificationEmail({ user, type: 'reset-password' })).unwrap();
    notification.success({
      message: 'Verification Email',
      description: 'Reset Password Email Sent Successfully',
      top: 65
    });
  };

  useEffect(() => {
    if (token) {
      const verifyEmail = async () => {
        const response = await dispatch(TokenVerification({ token, type: 'reset-password' }));
        if (!response.error) {
          // Store verification data for other tabs
          const verificationData = {
            timestamp: Date.now().toString(),
            token: token,
            email: emailReset,
            verified: true
          };
          localStorage.setItem('resetPasswordVerified', JSON.stringify(verificationData));
          notification.success({
            message: 'Token verified successfully',
            description: 'Your token has been verified successfully.',
            top: 65
          });
          navigate(`/auth/password-change?reset_password_token=${token}`);
        } else {
          notification.error({
            message: 'Token Verification Failed',
            description: response?.payload?.err?.data?.message || 'Your reset link is invalid or has expired. Please request a new one.',
            top: 65
          });
        }
        
      };
      verifyEmail();
    }
  }, [token]);

  useEffect(() => {
    const handleStorageEvent = (e) => {
      if (e.key === 'resetPasswordVerified' && e.newValue) {
        try {
          const verificationData = JSON.parse(e.newValue);
          if (verificationData.verified && window.location.href.includes('/password-email-verification')) {
            // Sync with other tabs by navigating to password change page with stored token
            navigate(`/auth/password-change?reset_password_token=${verificationData.token}`);
          }
        } catch (error) {
          console.error('Error parsing verification data:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageEvent);
    return () => {
      window.removeEventListener('storage', handleStorageEvent);
    };
  }, [navigate]);

  useEffect(() => {
    if (token) {
      const verifyEmail = async () => {
        const response = await dispatch(TokenVerification({ token, type: 'reset-password' }));
        if (!response.error) {
          // Store verification data for other tabs
          const verificationData = {
            timestamp: Date.now().toString(),
            token: token,
            email: emailReset,
            verified: true
          };
          localStorage.setItem('resetPasswordVerified', JSON.stringify(verificationData));
          notification.success({
            message: 'Token verified successfully',
            description: 'Your token has been verified successfully.',
            top: 65
          });
          navigate(`/auth/password-change?reset_password_token=${token}`);
        } else {
          notification.error({
            message: 'Token Verification Failed',
            description: response?.payload?.err?.data?.message || 'Your reset link is invalid or has expired. Please request a new one.',
            top: 65
          });
        }
        
      };
      verifyEmail();
    }
  }, [token]);

  useEffect(() => {
    const handleStorageEvent = (e) => {
      if (e.key === 'resetPasswordVerified' && e.newValue) {
        try {
          const verificationData = JSON.parse(e.newValue);
          if (verificationData.verified && window.location.href.includes('/password-email-verification')) {
            // Sync with other tabs by navigating to password change page with stored token
            navigate(`/auth/password-change?reset_password_token=${verificationData.token}`);
          }
        } catch (error) {
          console.error('Error parsing verification data:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageEvent);
    return () => {
      window.removeEventListener('storage', handleStorageEvent);
    };
  }, [navigate]);

  useEffect(() => {
    if (token) {
      const verifyEmail = async () => {
        const response = await dispatch(TokenVerification({ token, type: 'reset-password' }));
        if (!response.error) {
          // Store verification data for other tabs
          const verificationData = {
            timestamp: Date.now().toString(),
            token: token,
            email: emailReset,
            verified: true
          };
          localStorage.setItem('resetPasswordVerified', JSON.stringify(verificationData));
          notification.success({
            message: 'Token verified successfully',
            description: 'Your token has been verified successfully.',
            top: 65
          });
          navigate(`/auth/password-change?reset_password_token=${token}`);
        } else {
          notification.error({
            message: 'Token Verification Failed',
            description: response?.payload?.err?.data?.message || 'Your reset link is invalid or has expired. Please request a new one.',
            top: 65
          });
        }
        
      };
      verifyEmail();
    }
  }, [token]);

  useEffect(() => {
    const handleStorageEvent = (e) => {
      if (e.key === 'resetPasswordVerified' && e.newValue) {
        try {
          const verificationData = JSON.parse(e.newValue);
          if (verificationData.verified && window.location.href.includes('/password-email-verification')) {
            // Sync with other tabs by navigating to password change page with stored token
            navigate(`/auth/password-change?reset_password_token=${verificationData.token}`);
          }
        } catch (error) {
          console.error('Error parsing verification data:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageEvent);
    return () => {
      window.removeEventListener('storage', handleStorageEvent);
    };
  }, [navigate]);

  return (
    <AuthWrapper>
      <Header login={true} />
      <div className="auth-container-overlay-wrapper">
        <div className="auth-container">
          <div className="bg-albaster py-40">
            <div>
              <div className="mb-4">
                <h2>Reset Password Verification Email Sent</h2>
                {/* <span>Verification email sent description</span> */}
              </div>
              <div className="pt-120 pb-90 text-center">
                <img src={EmailVerifactionImage} alt="no-image-email" />
              </div>
              <div className="text-center">
                <span>If you didn’t receive the email or token expired please
                  {sendVerificationEmailLoading ? <a > Sending Email...</a>
                    : <a href='#' onClick={handleResendEmail}> Click Here</a>}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthWrapper>
  );
};

export default PasswordEmailVerifaction;
